/* eslint-disable react/prefer-stateless-function */
import React from 'react';

function pageWrapper(WrappedPage) {
  return class Page extends React.Component {
    render() {
      return (
        <div className="app app--anon">
          <section className="app-main">
            <div className="appPage">
              <WrappedPage {...this.props} />
            </div>
          </section>
        </div>
      );
    }
  };
}

export default pageWrapper;



// WEBPACK FOOTER //
// ./src/components/containers/AnonPage.jsx